var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMallArrow = function SvgMallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.767 1.909-.089-.476-.478.073-.287.043-.015.003-.014.003-.136.029-.136.029-.477.102.09.48c.365 1.93 1.21 3.205 2.189 4.043H.52v1.538h11.886c-1.01.839-1.876 2.122-2.197 4.055l-.083.5.5.076.277.042.142.027.02.004.021.003.136.014.47.05.076-.467c.315-1.934 1.264-2.978 2.243-3.56.987-.587 2.039-.72 2.583-.743.257.013.47 0 .425 0h.562l-.065-.558-.011-.102v-.034l.014-.338.023-.521H16.43c-.604-.035-1.596-.193-2.518-.789-.91-.588-1.794-1.63-2.146-3.526Zm5.253 5.164v-.297.297Z",
    fill: "#000",
    stroke: "#000"
  })));
};
export default SvgMallArrow;